'use strict';

var _ = require('lodash');

function MyProfileController ($scope, $timeout, UserStore, SaturnGrowl) {
  var vm = this;

  vm.edited = false;
  vm.user = {};
  vm.originalUser = {};

  UserStore.findUser().then(function(user) {
    vm.user = _.pick(user, ['firstName', 'lastName', 'email', 'title', 'company', 'phone']);
    vm.originalUser = _.clone(vm.user);
    $timeout(function() {
      vm.edited = false;
    });
  });

  vm.saveChanges = function() {
    UserStore.updateUser(vm.user).then(function() {
      SaturnGrowl.newGrowl('Your changes have been successfully saved!', {
        time: 2500
      });
      vm.originalUser = _.clone(vm.user);
      vm.edited = false;
    }).catch(function() {
      SaturnGrowl.newGrowl('Oh no! Something happened!', {
        type: 'warning'
      });
    });
  };

  vm.cancelEditUser = function() {
    vm.user = _.clone(vm.originalUser);
    $timeout(function() {
      vm.edited = false;
    });
  };

  $scope.$watch('vm.user', function() {
    vm.edited = true;
  }, true);
}

MyProfileController.$inject = ['$scope', '$timeout', 'UserStore', 'SaturnGrowl'];

module.exports = MyProfileController;



// WEBPACK FOOTER //
// ./src/app/settings/myProfile/MyProfileController.js